import { Button, Footnote, Modal } from '../../../components/ui';
import { formatCount, formatDateTime } from '../../../lib/format';
import type { CompanySummary } from '../../../types';
import type { EmailUnsubscribe } from '../types';
import { mascararEmail } from '../vocabulario';

/**
 * Lista de descadastrados (amostra), com o e-mail mascarado.
 *
 * Mesma regra do telefone: a tela fica aberta em escritorio e ninguem
 * precisa do endereco inteiro para reconhecer um caso de suporte.
 */
export function ModalDescadastrados({
  open,
  onClose,
  descadastrados,
  total,
  companies,
}: {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly descadastrados: readonly EmailUnsubscribe[];
  readonly total: number;
  readonly companies: readonly CompanySummary[];
}): JSX.Element | null {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Descadastrados"
      description={`${formatCount(total)} ${total === 1 ? 'pessoa pediu' : 'pessoas pediram'} para não receber mais e-mails no período. Nunca entram em campanha nenhuma.`}
      footer={
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      {descadastrados.length === 0 ? (
        <p className="text-sm text-ink-muted">Nenhum descadastro registrado.</p>
      ) : (
        <ul className="flex flex-col divide-y divide-line" aria-label="Amostra de descadastrados">
          {descadastrados.map((d) => (
            <li key={d.id} className="flex flex-wrap items-start justify-between gap-2 py-2.5 text-sm">
              <div className="min-w-0">
                <p className="font-medium text-ink">{mascararEmail(d.email)}</p>
                <p className="text-xs text-ink-subtle">
                  {companies.find((c) => c.id === d.companyId)?.name ?? 'Empresa'} · saiu em "{d.campaignSubject}"
                </p>
              </div>
              <span className="shrink-0 text-xs tabular-nums text-ink-subtle">{formatDateTime(d.at)}</span>
            </li>
          ))}
        </ul>
      )}
      {total > descadastrados.length ? (
        <div className="mt-3">
          <Footnote>
            Mostrando {formatCount(descadastrados.length)} de {formatCount(total)}. A lista completa e a exportação chegam com o backend.
          </Footnote>
        </div>
      ) : null}
    </Modal>
  );
}
